import {Image} from "@mantine/core";
import React from "react";


const PIPSEnContent = () => {
    return (
        <>

            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>Issue Date: March 20, 2023</div>
                <div>The purpose of the Notice is to inform you of the following information when collecting your
                    personal data as required by Article 8 of Personal Data Protection Act.
                </div>
            </div>


            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">1. Personal Data Controller:</div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>Science & Technology Policy Research and Information Center, NIAR ("STPI")</div>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">2. Purpose of Collection：</div>
            <div className="text-[20px] leading-[40px] mb-[45px] space-y-[45px]">
                <div>
                    The purpose that STPI collects your personal data are for the implementation of STPI's research
                    activities, management of science and technology personnel, membership and customer management,
                    marketing, internal statistical surveys and analysis, and operations that STPI carries out as
                    statutory obligations.
                </div>
                <div>
                    Specific objective purposes include: Statutory Specific Purposes: 040 Marketing; 075 Technology
                    Administration; Plan, control, evaluation and other research and evaluation management; 090
                    Consumer, Customer Management and Service; 129 Accounting and related Services; 130 Meeting
                    Management; 172 Other public sectors implement relevant business (including the non-departmental
                    public body, government-sponsored foundation and other public legal person); 181 Other business
                    operation in accordance with the business registration project or organization Prospectus.
                </div>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">3. Types of Personal Data Collected by
                STPI:
            </div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div className="flex gap-2">
                    <div>3.1</div>
                    <div>Type for identifying individuals. For example: Name, address, telephone number, cell phone
                        number, and E-mail address.
                    </div>
                </div>
                <div className="flex gap-2">
                    <div>3.2</div>
                    <div>Type for identifying finance. For example: Account.</div>
                </div>
                <div className="flex gap-2">
                    <div>3.3</div>
                    <div>Type for identifying in government data. For example: The number of personal ID card or the
                        number of passport (a foreign national).
                    </div>
                </div>
                <div className="flex gap-2">
                    <div>3.4</div>
                    <div>Individual description. For example: Age, nationality, date of birth, and works.</div>
                </div>
                <div className="flex gap-2">
                    <div>3.5</div>
                    <div>We use cookies to manage and track activity records, including your IP address, browser type,
                        and browsing time, when you're on STPI's website.
                    </div>
                </div>
                <div className="flex gap-2">
                    <div>3.6</div>
                    <div>The above types of personal data are defined in the Personal Data Protection Act as the
                        classifications below: C001, C002, C003, C011, C051, C052, C056, and C061.
                    </div>
                </div>
            </div>


            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">4
                4. The Time Period and Territory of Use, Recipients and Uses of Collected Personal Data
            </div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div className="flex gap-2">
                    <div>4.1</div>
                    <div>
                        The term of use of personal data shall be the duration of the organization or business, with no restriction on the geographical area of use.
                    </div>
                </div>
                <div className="flex gap-2">
                    <div>4.2</div>
                    <div>Methods of use:</div>
                </div>
                <div className="flex gap-2 ps-6">
                    <div>a)</div>
                    <div>Email: Used for communication purposes.</div>
                </div>
                <div className="flex gap-2 ps-6">
                    <div>b)</div>
                    <div>Office telephone: Used for relevant business contacts within the organization.</div>
                </div>
                <div className="flex gap-2 ps-6">
                    <div>c)</div>
                    <div>Mobile phone: Used for message transmission in addition to business contacts.</div>
                </div>
                <div className="flex gap-2">
                    <div>4.3</div>
                    <div>
                        Recipients of the data: This center, entities entrusted by this center, and entities entrusted by the center.
                    </div>
                </div>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">5. Rights and Interests of the Data Subject</div>
            <div className="text-[20px] leading-[40px] mb-[45px]">
                <div>
                    You can exercise your rights as stipulated in Article 3 of the Personal Data Protection Act. For ways to exercise the rights, please call or email the service staff of STPI.
                </div>
                <div>E-mail: <a className="text-blue-700 underline px-2" href="mailto:privacy.stpi@niar.org.tw">privacy.stpi@niar.org.tw</a></div>
            </div>

            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">6. Where you choose not to provide personal information marked as optional, your rights will not be affected when STPI collects your personal data.</div>
            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">7. STPI reserves the right to modify the Notice and will notify you through the contact information provided by you or through an announcement on the website after the modification. Not raising any objection or continuing to use the services provided by STPI means that you agree to the modified content.</div>
            <div className="text-[#8d7f4c] text-[30px] font-bold mb-[25px]">8. If you fail to provide the above-mentioned personal data required for STPI's operations, STPI will not be able to provide services or process your request.</div>

            <div className="text-[20px] leading-[40px] mb-[45px]">
                I have read the above Notice carefully and agree to the content.
            </div>
        </>
    );
}

export default PIPSEnContent;
